import { Maybe, PromptSetting } from 't2-graphql-types';
import { PromptSettingsLiveStatus } from '../Prompt/constants';

type TGetLivePromptVariablesArgs = { promptSettings?: Maybe<PromptSetting>; startDate?: Date; endDate?: Date };

export const getLivePromptVariables = ({ promptSettings, startDate, endDate }: TGetLivePromptVariablesArgs) => {
  const isCompleted = promptSettings?.liveStatus === PromptSettingsLiveStatus.COMPLETED;
  const isLive = promptSettings?.liveStatus === PromptSettingsLiveStatus.LIVE;

  return {
    promptSettingsId: promptSettings?.id,
    startDate: isCompleted || isLive ? undefined : startDate,
    endDate: isCompleted ? undefined : endDate,
  };
};
